import { PERMISSIONS } from "../roles-permissions/permission-catalog";
import { defineEntityIdentity } from "../_shared/entity-identity.schemas";

export const contactsIdentity = defineEntityIdentity({
	definitionKey: "contacts",
	pageKey: "contacts",
	nameSingular: "contact",
	namePlural: "contacts",
	relationKey: "contact",
	auditKey: "contacts",
	storage: "durable",
	grants: {
		read: { ...PERMISSIONS.contacts.readAll, audience: "allMembers" },
		create: {
			...PERMISSIONS.contacts.createAll,
			audience: "restricted",
			assignByEmail: ["bferguson@fergmar.com"]
		},
		update: {
			...PERMISSIONS.contacts.updateAll,
			audience: "restricted",
			assignByEmail: ["bferguson@fergmar.com"]
		},
		delete: { ...PERMISSIONS.contacts.deleteAll, audience: "restricted" }
	}
});
